import { Api } from '../lib'

const TYPE = {
  receive_home: 'RECEIVE_HOME',
  receive_page: 'RECEIVE_PAGE'
}

const api = new Api()

const fetchPage = ({keys}, type) => (dispatch, getState) => api
  .get('page', {
    keys,
  })

  .then( page => {
    if (type === 'home_page')
      dispatch({type: TYPE.receive_home, payload: page.data})
    else
      dispatch({type: TYPE.receive_page, payload: page.data})
  })

export default {
  TYPE,
  fetchPage
}
